// extracted by mini-css-extract-plugin
module.exports = {"root":"articlecard_root__opQQ9"};